import {
	CategoryGroupOverviewItem,
	GroupGroupOverviewItem
} from "client/Api/Hub/KnowledgeItems/knowledgeItemViewer";
import { Anchor, Space } from "client/Components";
import { setTrackingId } from "client/Misc/utils";
import { ReactElement } from "react";
import styles from "./GroupOverviewCardItem.module.less";
import { Thumbnail } from "./Thumbnail";
import { formatNewItemsCount } from "client/Features/Hub/common";
import { localize } from "client_legacy/ndaw/culture";
import { CardStatus } from "client/Features/Workspace/Tiles/Hub/Card/CardStatus/CardStatus";

export type GroupOverviewCardItemProps = {
	title: string;
	newItemsCount: number;
	description: string | null;
	imageUrl: string | null;
	trackingId: string;
	onClick: () => void;
};

export const GroupOverviewCardItem = (props: GroupOverviewCardItemProps): ReactElement => {
	const {
		title,
		newItemsCount,
		description,
		imageUrl,
		trackingId,
		onClick
	} = props;

	return (
		<div
			{...setTrackingId(trackingId)}
			className={styles.root}
			onClick={onClick}
		>
			<div className={styles.thumbnail}>
				<div className={styles.thumbnailScaleContainer}>
					<Thumbnail
						imageUrl={imageUrl}
						mediaPlaceholderSize="large"
					/>
				</div>
				{newItemsCount > 0 && (
					<div className={styles.counter}>
						<CardStatus
							trackingId="status"
						>
							{formatNewItemsCount(newItemsCount)}
							<Space />
							{localize("_New")}
						</CardStatus>
					</div>
				)}
			</div>

			<div
				{...setTrackingId("content")}
				className={styles.content}
			>
				<h3 className={styles.title}>
					<Anchor
						trackingId="title"
						className={styles.titleLink}
						title={title}
					>
						{title}
					</Anchor>
				</h3>
				<div className={styles.description}>
					{description}
				</div>
			</div>
		</div>
	);
};
GroupOverviewCardItem.displayName = "GroupOverviewCardItem";

export enum OverviewItemKind {
	Category = 0,
	Group = 1
}

type BaseItemModel = {
	uniqueKey: string;
	name: string;
	newItemsCount: number;
};

export type DetailsState<TDetails> = {
	status: "loading";
} | {
	status: "error";
} | {
	status: "ready";
	details: TDetails;
};

export type GroupOverviewItem = BaseItemModel & {
	kind: OverviewItemKind.Group;
	groupId: number;
	state: DetailsState<GroupGroupOverviewItem>;
};

export type CategoryOverviewItem = BaseItemModel & {
	kind: OverviewItemKind.Category;
	categoryId: number;
	state: DetailsState<CategoryGroupOverviewItem>;
};

export type OverviewItem =
	| CategoryOverviewItem
	| GroupOverviewItem;